var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.style)},[_vm._v("\n    "+_vm._s(_vm.rendered)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }